import { TabList, Wrapper, TabButton } from '@/components/TabSelector.styles'
import { useEffect, useState } from 'react'
import { Tab } from '@headlessui/react'
import { Body, BodySize, Heading, Spacing } from '@big-red-group/storefront-common-ui'
import { ClickEventHandlerInput } from '@/types'

export type SelectorTab = {
  label: string
  children: React.ReactNode
}

const TabSelector: React.FC<{
  updateActiveTab: number
  tabs: SelectorTab[]
  className?: string
  noSpacing?: boolean
  size?: BodySize
  onLinkClick?: (params: ClickEventHandlerInput) => void
}> = ({ updateActiveTab, tabs, className, noSpacing = false, size = 'M', onLinkClick }) => {
  const [activeTab, setActiveTab] = useState<number>(0)

  useEffect(() => {
    setActiveTab(updateActiveTab)
  }, [updateActiveTab])

  return (
    <Wrapper>
      <Heading size="L" as="div" dataTestId="product-travellers">
        I want to
      </Heading>
      <Spacing size="S" />
      <Tab.Group selectedIndex={activeTab}>
        <div className={className}>
          <TabList>
            {tabs.map((tab, index) => (
              <TabButton
                key={tab.label}
                onClick={(event: any) => {
                  setActiveTab(index)
                  onLinkClick?.({ url: window.location.href, location: 'PDP | Booking | Tab Selector', event })
                }}
                $numTabs={tabs.length}
                data-testid={`tab-selector-tab-${index}`}
              >
                <Body size={size as BodySize} weight="bold">
                  {tab.label}
                </Body>
              </TabButton>
            ))}
          </TabList>
        </div>
        {!noSpacing && <Spacing size="M" />}
        <Tab.Panels>
          {tabs.map((tab) => {
            return <Tab.Panel key={tab.label}>{tab.children}</Tab.Panel>
          })}
        </Tab.Panels>
      </Tab.Group>
    </Wrapper>
  )
}

export default TabSelector
